module.exports = __webpack_public_path__ + "static/media/wishlist_banner.72c0bddb.webp";